"use strict";

exports.__esModule = true;
exports.HlsManifestParser = void 0;
var _StringUtils = require("../Utils/StringUtils");
var _YoLog = require("../Utils/YoLog");
var _Constant = require("../Utils/Constant");
var _PlaylistPayload = require("./PlaylistPayload");
var _HttpUtils = require("../Utils/HttpUtils");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var EXT3MU = "#EXTM3U";
var JSESSION_PATTERN = /;jsessionid=([^?]+)/;
var YO_JS_PATTERN = /yo\.js=([^?]+)/;
var PAYLOADFIRSTLEVEL = "FIRSTLEVELPLAYLIST";
var EXT_YOSPACE_ANALYTICS_URL = "#EXT-X-YOSPACE-ANALYTICS-URL";
var EXT_X_STREAM_INF = "#EXT-X-STREAM-INF";
var EXT_X_YOSPACE_PAUSE = "#EXT-X-YOSPACE-PAUSE";
var EXT_YOSPACE_MASTER_URL = "#EXT-X-YOSPACE-SDK-MASTER-URL";
var HlsManifestParser = exports.HlsManifestParser = /*#__PURE__*/function () {
  function HlsManifestParser() {
    this.data = new Map();
    this.nextLineStreamInf = false;
  }
  var _proto = HlsManifestParser.prototype;
  _proto.buildPlaybackUrl = function buildPlaybackUrl() {
    var masterUrl = this.data.get(_Constant.Payload.LOCATION);
    if (masterUrl && !(0, _HttpUtils.getUrl)(masterUrl)) {
      _YoLog.YoLog.w("Master URL invalid in HSL manifest: " + masterUrl);
      this.data["delete"](_Constant.Payload.LOCATION);
    }
    var isYoJs = false;
    var location = this.data.get(_Constant.Payload.LOCATION);
    if (!location) {
      location = this.data.get(PAYLOADFIRSTLEVEL);
    }
    if (!location) {
      _YoLog.YoLog.e("No location or first level URL available");
      return false;
    }
    var loc = (0, _HttpUtils.getUrl)(location);
    var yojsMatch = location.match(YO_JS_PATTERN);
    var jsessMatch = location.match(JSESSION_PATTERN);
    if (loc) {
      // Parse the session id
      if (yojsMatch) {
        isYoJs = true;
        this.data.set(_Constant.Payload.IDENTIFIER, yojsMatch[1]);
      } else if (jsessMatch) {
        this.data.set(_Constant.Payload.IDENTIFIER, jsessMatch[1]);
      }
    }
    if (!loc || this.data.get(_Constant.Payload.IDENTIFIER) === undefined) {
      _YoLog.YoLog.e("Unable to build Location from components");
      return false;
    }
    var port = loc.port;
    this.data.set(_Constant.Payload.PORT, port === "" ? "" : port);
    this.data.set(_Constant.Payload.SCHEME, loc.protocol.substring(0, loc.protocol.length - 1));
    this.data.set(_Constant.Payload.HOSTNODE, loc.hostname);
    this.data.set(_Constant.Payload.QS, loc.search ? loc.search.replace('?', '') : '');
    this.updateLocationPath(loc, isYoJs);
    return true;
  };
  _proto.updateLocationPath = function updateLocationPath(loc, isYoJs) {
    if (!this.data.get(_Constant.Payload.LOCATION)) {
      // replace the final path fragment with the final path fragment of the master request URL
      var oldpath = loc.pathname;
      var path = oldpath.substring(0, oldpath.lastIndexOf('/')) + ".m3u8";
      var location = this.data.get(_Constant.Payload.SCHEME);
      location += "://";
      location += this.data.get(_Constant.Payload.HOSTNODE);
      location += this.data.get(_Constant.Payload.PORT) !== "" ? ":" + this.data.get(_Constant.Payload.PORT) : "";
      location += path;
      if (!isYoJs) {
        location += ";jsessionid=" + this.data.get(_Constant.Payload.IDENTIFIER);
      }
      if (!(0, _StringUtils.isNullOrEmpty)(this.data.get(_Constant.Payload.QS))) {
        location += "?" + this.data.get(_Constant.Payload.QS);
      }
      this.data.set(_Constant.Payload.LOCATION, location);
    }
  };
  HlsManifestParser.checkParameters = function checkParameters(hlsManifest) {
    if ((0, _StringUtils.isNullOrEmpty)(hlsManifest)) {
      _YoLog.YoLog.e("Yospace HLS manifest is empty");
      return false;
    }
    if (hlsManifest.indexOf("#EXT-X-STREAM-INF:") === -1) {
      _YoLog.YoLog.e("No stream info found in HLS manifest");
      return false;
    }
    return true;
  };
  HlsManifestParser.isHlsManifest = function isHlsManifest(content) {
    return content.length >= 7 && content.toUpperCase().indexOf(EXT3MU) !== -1;
  };
  _proto.parseManifestLines = function parseManifestLines(hlsManifest) {
    var hlsManifestLines = hlsManifest.split(/\r?\n/);
    for (var _iterator = _createForOfIteratorHelperLoose(hlsManifestLines), _step; !(_step = _iterator()).done;) {
      var line = _step.value;
      if (line.length === 0) {
        continue;
      }
      if (line.startsWith("#")) {
        this.processManifestDirective(line);
      } else if (this.nextLineStreamInf && !this.data.has(PAYLOADFIRSTLEVEL)) {
        this.data.set(PAYLOADFIRSTLEVEL, line);
      }
    }
  };
  _proto.processManifestDirective = function processManifestDirective(line) {
    var colon = line.indexOf(":");
    if (colon === -1) {
      return;
    }
    var meta = line.substring(colon + 1);
    var key = line.substring(0, colon);
    if (key.includes(EXT_YOSPACE_ANALYTICS_URL)) {
      this.data.set(_Constant.Payload.ANALYTICURL, meta.replace(/"/g, ""));
    } else if (key.includes(EXT_X_STREAM_INF)) {
      if (!this.data.has(PAYLOADFIRSTLEVEL)) {
        this.nextLineStreamInf = true;
      }
    } else if (key.includes(EXT_X_YOSPACE_PAUSE)) {
      this.data.set(_Constant.Payload.PAUSEURL, meta.replace(/"/g, ""));
    } else if (key.includes(EXT_YOSPACE_MASTER_URL)) {
      this.data.set(_Constant.Payload.LOCATION, meta.replace(/"/g, ""));
    }
  };
  HlsManifestParser.parse = function parse(hlsManifest) {
    var parser = new HlsManifestParser();
    if (HlsManifestParser.checkParameters(hlsManifest)) {
      parser.parseManifestLines(hlsManifest);
      parser.buildPlaybackUrl();
      return new _PlaylistPayload.PlaylistPayload(parser.data, _Constant.Constant.INTERSEGMENT_TIMEOUT);
    }
    return null;
  };
  return HlsManifestParser;
}();